import script from "./MarkdownViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./MarkdownViewer.vue?vue&type=script&setup=true&lang=js"

import "./MarkdownViewer.vue?vue&type=style&index=0&id=c0f07e9e&lang=css"

const __exports__ = script;

export default __exports__